import { render, staticRenderFns } from "./ComplexRegulationRequirementItem.vue?vue&type=template&id=7443fb56&scoped=true&"
import script from "./ComplexRegulationRequirementItem.vue?vue&type=script&lang=js&"
export * from "./ComplexRegulationRequirementItem.vue?vue&type=script&lang=js&"
import style0 from "./ComplexRegulationRequirementItem.vue?vue&type=style&index=0&id=7443fb56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7443fb56",
  null
  
)

export default component.exports